import { configureStore } from "@reduxjs/toolkit";
import filterReducer from "./slices/FilterSlice";
import formReducer from "./slices/FormSlice";
import secFilterReducer from "./slices/secFilterSlice";
import ComplaintfilterSlice from "./slices/FilterSliceComplaint";
import OfftakefilterSlice from "./slices/FilterSliceOfftake";
import StockfilterSlice from "./slices/FilterSliceStock";
import PipelinefilterSlice from "./slices/FilterSlicePipeline";
import LeadSourcefilterSlice from "./slices/FilterSliceLeadSource";
import DealerReviewfilterSlice from "./slices/FilterSliceDealerReview";
import SalesSuccessCenterfilterSlice from "./slices/FilterSliceSalesSuccessCenter";
import PvinFilterSlice from "./slices/FilterSlicePvin";
import ManpowerDealerReviewfilterSlice from "./slices/FilterSliceManpowerDealerReview";
import RealizationFilterSlice from "./slices/FilterSliceRealization";
import PowerDeckfilterSlice from "./slices/FilterSlicePowerDeck";
import ServiceCollabaxFilterSlice from "./slices/FilterSliceServiceCollabax";

const store = configureStore({
  reducer: {
    filters: filterReducer,
    forms: formReducer,
    secFilters: secFilterReducer,
    filtersComplaint: ComplaintfilterSlice,
    filtersOfftake: OfftakefilterSlice,
    filtersStock: StockfilterSlice,
    filtersPipeline: PipelinefilterSlice,
    filtersLeadSource: LeadSourcefilterSlice,
    filtersDealerReview: DealerReviewfilterSlice,
    filtersSalesSuccessCenter: SalesSuccessCenterfilterSlice,
    filtersPvin: PvinFilterSlice,
    filtersManpowerDealerReview: ManpowerDealerReviewfilterSlice,
    filtersRealization: RealizationFilterSlice,
    filtersPowerDeck: PowerDeckfilterSlice,
    filtersServiceCollabax: ServiceCollabaxFilterSlice,
  },
});

export default store;
